import { extractImage } from '@atlaskit/link-extractors';
import { MediaType } from '../../constants';
var extractPreview = function extractPreview(data) {
  if (!data) {
    return undefined;
  }
  var url = extractImage(data);
  return url ? {
    type: MediaType.Image,
    url: url
  } : undefined;
};
export default extractPreview;